export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_9867_SCORECARD_CATEGORIES': 'Scorecard Categories',
    '_9868_PREVIOUS_SCORECARD_CATEGORY': 'Previous Scorecard Category',
    '_9869_CURRENT_CATEGORY': 'Current Category',
    '_9853_IMPROVEMENT_CATEGORY': 'Improvement Category',
    '_9878_MI2_SCORE': 'MI2 Score'
};
